export default __webpack_public_path__ + "static/TruckAccident-c3efd5e869a5cd69df5bb3abad01fb3f.svg";